import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appConstants from "../../../constants/appConstants";
import * as appHelper from '../../../helpers/appHelper';

class NotReadyYet extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: props.lang,
            onContinue: props.onContinue,
            screen_not_ready_label: appHelper.getLocaleString("screen_not_ready_label"),
            continue_label: appHelper.getLocaleString("continue_label"),
            next_label: appHelper.getLocaleString("next_label"),
        };
        this.getImagePath = this.getImagePath.bind(this);

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                screen_not_ready_label: appHelper.getLocaleString("screen_not_ready_label"),
                continue_label: appHelper.getLocaleString("continue_label"),
                next_label: appHelper.getLocaleString("next_label"),
            });
        }
    }

    componentDidUpdate() {

    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }


    render() {
        return (
            <div className={`object-container`} ref={`${this.props.screen_id}_text`} style={{width: `100%`}}>
               <div className="screen-not-ready">
                   <div className="content">{this.state.screen_not_ready_label}</div>
                   <div className="flex-1 text-right">
                       <Button ref={`${this.props.screen_id}_button`}
                               label={this.state.next_label}
                               id={`${this.props.screen_id}_button`}
                               onClick={this.props.onContinue}

                       />
                   </div>
                </div>


            </div>
        );
    }
}

NotReadyYet.propTypes = {
    screen_id: PropTypes.number.isRequired,
    lang: PropTypes.string.isRequired,
    onContinue: PropTypes.func.isRequired,
    buttonLabel: PropTypes.string,
    actions: PropTypes.object.isRequired
};

NotReadyYet.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotReadyYet);



/** WEBPACK FOOTER **
 ** ./src/components/objects/producerNotes/NotReadyYet.js
 **/